import React from 'react';
import RoomList from './completedPresentation/roomList/RoomList';
import MainInfoSection from './completedPresentation/MainInfoSection';
import PublicPortraitSection from './completedPresentation/PublicPortraitSection';
import ImagesSection from './completedPresentation/ImagesSection';
import useUserProfile from '../../../../customHooks/useUserProfile';
import { Alert } from '@mui/material';
import useTranslate from '../../../../customHooks/useTranslate';

const CompletedPropertyPresentation = () => {
    const { readOnlyUser } = useUserProfile();
    const readOnlyText = useTranslate('read_only_hotels');

    return (
        <div className='completed-presentation__page'>
            <ImagesSection />
            {readOnlyUser ? (
                <Alert
                    severity='warning'
                    sx={{
                        width: '100%',
                        justifyContent: 'center',
                        border: '1px solid #ff9800',
                    }}
                >
                    {readOnlyText}
                </Alert>
            ) : (
                ''
            )}
            <MainInfoSection />
            <PublicPortraitSection />
            <RoomList />
        </div>
    );
};

export default CompletedPropertyPresentation;
